import { EntityKind } from '../types/enums'

const locale = 'fr-CH'

export function isDateValid(date?: string | Date) {
  if (!date) return false
  const time = new Date(date).getTime()
  return time > 0 && time < 30000000000000
}

export function getValidDate(date?: string) {
  if (!date) return undefined

  const splitDate = date.split('.')
  const isValidDateButWrongFormat = splitDate.length === 3 && splitDate[0].length === 2 && splitDate[1].length === 2
  if (isValidDateButWrongFormat) {
    const properDate = new Date(Number(splitDate[2]), Number(splitDate[1]), Number(splitDate[0]))
    if (!isNaN(properDate.getTime())) {
      return properDate
    }
  }
  return new Date(date)
}

export const printDate = (date: Date | undefined | null | string, withTime = false) => {
  if (date) {
    const convertedDate = new Date(date)
    if (typeof date === 'string' && isNaN(convertedDate.getTime())) {
      return date
    }
    return withTime
      ? `${convertedDate.toLocaleDateString(locale)} - ${convertedDate.toLocaleTimeString(locale, {
          hour: '2-digit',
          minute: '2-digit',
        })}`
      : new Date(date).toLocaleDateString(locale)
  }
  return '-'
}

export const zeroTimeZoneDate = (date: Date) => {
  const timeZoneDifference = date.getTimezoneOffset() * 60000
  const modifiedDate = new Date(date.getTime() - timeZoneDifference)
  return modifiedDate
}

export function getEntityKind(entityId: string): EntityKind | undefined {
  const idParts = entityId.split('-')
  const entityKindPart = idParts[2]
  const entityKindValue = parseInt(`0x${entityKindPart}`, 16)

  if (EntityKind[entityKindValue] !== undefined) {
    return entityKindValue as EntityKind
  }
  return undefined
}

export const parseFileData = (value?: string) => {
  if (value) {
    const fileArr = value.split('|')
    const fileURL = fileArr[1]
    const filename = fileArr[0]
    if (fileURL && filename) {
      return { fileURL, filename }
    }
  }
  return undefined
}
